import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import httpHelper from '../../helpers/HttpHelper';
import { groupAsectionOrder } from '../../helpers/constants';
import { PowerBIEmbed } from 'powerbi-client-react';
import Arrowdiagonal from '../../assets/images/Arrowdiagonal.png';
import { models } from 'powerbi-client';
import Spinner from '../common/spinner';
import './GroupA.scss';
import environment from '../common/environments/environments';
import { SwitchLanguage, Reset } from '../../store/slices/userSlice';

const GroupA = props => {
	const http = new httpHelper(); // eslint-disable-line
	const [powerBIOneData, setPowerBIOneData] = useState(null);
	const [report, setReport] = useState();
	const [reportOne, setReportOne] = useState();
	const [reportTwo, setReportTwo] = useState();
	const [reportThree, setReportThree] = useState();
	const [reportFour, setReportFour] = useState();
	const [enableSearch, setEnableSearch] = useState(false);
	const [enableKeyBtn, setEnableKeyBtn] = useState(null);
	const [enableSatBtn, setEnableSatBtn] = useState(null);
	const [enableOutBtn, setEnableOutBtn] = useState(null);
	const [enableInvBtn, setEnableInvBtn] = useState(null);
	const [dashboardAccess, setDashboardAccess] = useState({
		KEYSTATISTICS: false,
		SATISFACTION: false,
		OUTCOMES: false,
		INVOICING: false
	});
	const [enableKeySection, setEnableKeySection] = useState(false);
	const [enableSatSection, setEnableSatSection] = useState(false);
	const [enableOutSection, setEnableOutSection] = useState(false);
	const [enableInvSection, setEnableInvSection] = useState(false);
	const [allowedSections, setAllowedSections] = useState({});
	const [userSelectedCurrency, setUserSelectedCurrency] = useState('DEFAULT');
	let userId = window.sessionStorage.getItem('UserId');
	let myOneRef = useRef();
	let myTwoRef = useRef();
	let myThreeRef = useRef();
	let myFourRef = useRef();

	useEffect(() => {
		console.log('GROUPA DASHBOARD LANGUAGE SELECTED1', props.userSelectedlanguage); // eslint-disable-line
		console.log('GROUPA EMBEDDED URL1', sessionStorage.getItem('GROUPA_EMBED_URL')); // eslint-disable-line
		getDashboardList();
		console.log('GROUP A CONFIG VALUES::', props.groupAConfig); // eslint-disable-line
	}, []);
	/* eslint-disable */
	const getDashboardList = async () => {
		let payload = {};
		await http
			.Get(environment.USERDASHBOARDLIST + '/' + userId + '/' + environment.BRAND_ID + '/userdashboardlist', payload)
			.then(res => {
				console.log(res.data); // eslint-disable-line
				let groupAsections = [];
				res.data.map(dashboardData => {
					if (dashboardData.TypeDescription === 'Group A  - Key Statistics') {
						setDashboardAccess(dashboardAccess => ({ ...dashboardAccess, KEYSTATISTICS: true }));
						groupAsections.push('KEYSTATISTICS');
					} else if (dashboardData.TypeDescription === 'Group A - Satisfaction') {
						setDashboardAccess(dashboardAccess => ({ ...dashboardAccess, SATISFACTION: true }));
						groupAsections.push('SATISFACTION');
					} else if (dashboardData.TypeDescription === 'Group A - Outcomes') {
						setDashboardAccess(dashboardAccess => ({ ...dashboardAccess, OUTCOMES: true }));
						groupAsections.push('OUTCOMES');
					} else if (dashboardData.TypeDescription === 'Group A - Invoicing') {
						setDashboardAccess(dashboardAccess => ({ ...dashboardAccess, INVOICING: true }));
						groupAsections.push('INVOICING');
					}
				});
				let sortOrder = groupAsectionOrder;
				groupAsections.sort(function (a, b) {
					return sortOrder.indexOf(a) - sortOrder.indexOf(b);
				});
				setAllowedSections(groupAsections);

				if (groupAsections[0] === 'KEYSTATISTICS') {
					setEnableKeySection(true);
				} else if (groupAsections[0] === 'SATISFACTION') {
					setEnableSatSection(true);
				} else if (groupAsections[0] === 'OUTCOMES') {
					setEnableOutSection(true);
				} else if (groupAsections[0] === 'INVOICING') {
					setEnableInvSection(true);
				}
			})
			.catch(error => {
				//console.log(error);
				return error;
			});
	};
	/* eslint-enable */
	useEffect(() => {
		//console.log('sesss', sessionStorage.getItem('GROUPA_REPORT_ID'));
		if (dashboardAccess && props?.groupAConfig) {
			//reloadPowerBI();
			setPowerBIOneData(sessionStorage.getItem('GROUPA_REPORT_ID'));
		}
	}, [dashboardAccess, props.groupAConfig]);

	useEffect(() => {
		if (props.isLangChanged) {
			reloadPowerBI();
			props.reset();
		}
	}, [props.isLangChanged, props.userSelectedlanguage]);

	useEffect(() => {
		console.log('updateGroupADashboard GROUPA::', localStorage.getItem('updateGroupADashboard')); // eslint-disable-line
		if (props?.groupAConfig && localStorage.getItem('updateGroupADashboard') == 1) {
			localStorage.setItem('updateGroupADashboard', 0);
			reloadPowerBI();
		}
	}, [props.groupAConfig]);

	const reloadPowerBI = async () => {
		//console.log('retest');
		let payload = {};
		await http
			.Get(
				environment.POWER_BI_API +
					'/' +
					props?.groupAConfig['GROUPA'].trim() +
					'/' +
					props?.groupAConfig['WORKSPACE_ID'].trim() +
					'/' +
					props?.userSelectedlanguage.toLowerCase() +
					'/accesstoken',
				payload
			)
			.then(res => {
				setPowerBIOneData(res.data);
				sessionStorage.setItem('GROUPA_REPORT_ID', res.data.ReportId);
				sessionStorage.setItem('GROUPA_EMBED_URL', res.data.EmbedUrl);
				sessionStorage.setItem('GROUPA_ACCESS_TOKEN', res.data.AccessToken);
				sessionStorage.setItem('GROUPA_CURRENCY_CODE', res.data.CurrencyCode);
			})
			.catch(error => {
				//console.log(error);
				return error;
			});
	};

	const updateReport = async () => {
		console.log('lang', props?.userSelectedlanguage.toLowerCase()); // eslint-disable-line
		console.log('GROUPA DASHBOARD LANGUAGE SELECTED2', props.userSelectedlanguage); // eslint-disable-line
		console.log('GROUPA EMBEDDED URL2', sessionStorage.getItem('GROUPA_EMBED_URL')); // eslint-disable-line
		//console.log('SESSION FOR POER BI', sessionStorage.getItem('GROUPA_EMBED_URL'));
		let selectedProgram = [];
		let selectedBunit = [];
		let selectedCountry = [];
		let selectedCurrency = '';
		// Retrieve the page collection and get the visuals for the active page.
		try {
			const pages = await report.getPages();
			let pageWithSlicer = pages.filter(function (page) {
				return page.isActive;
			})[0];
			const visuals = await pageWithSlicer.getVisuals();
			console.log('GROUPA ALL FILTERS', visuals); // eslint-disable-line
			// GET COUNTRY Retrieve the target visual.
			let slicer = visuals.filter(function (visual) {
				return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_FILTER_COUNTRY'].trim();
			})[0];
			// Get the slicer state
			const state = await slicer.getSlicerState();
			//console.log(state.filters[0]);
			if (state.filters[0] && state.filters[0].values.length > 0) {
				selectedCountry.push(state.filters[0].values);
			}

			// PROGRAM Retrieve the target visual.
			let progslicer = visuals.filter(function (visual) {
				return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_FILTER_PROGRAM'].trim();
			})[0];
			// Get the slicer state
			const progstate = await progslicer.getSlicerState();
			if (progstate.filters[0] && progstate.filters[0].values.length > 0) {
				selectedProgram.push(progstate.filters[0].values);
			}

			// BUSINESSUNIT Retrieve the target visual.
			let busUnitslicer = visuals.filter(function (visual) {
				return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_FILTER_BUSINESSUNIT'].trim();
			})[0];
			//console.log('busUnitslicer', busUnitslicer);
			// Get the slicer state
			const busUnitstate = await busUnitslicer.getSlicerState();
			if (busUnitstate.filters[0] && busUnitstate.filters[0].values.length > 0) {
				selectedBunit.push(busUnitstate.filters[0].values);
			}

			// CURRENCT Retrieve the target visual.
			let currencyslicer = visuals.filter(function (visual) {
				return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_FILTER_CURRENCY']?.trim();
			})[0];
			//console.log('busUnitslicer', busUnitslicer);
			// Get the slicer state
			const currencystate = await currencyslicer.getSlicerState();
			if (currencystate.filters[0] && currencystate.filters[0].values.length > 0) {
				selectedCurrency = currencystate.filters[0].values;
			}

			console.log('SELECTED COUNTRY', selectedCountry); // eslint-disable-line
			console.log('SELECTED PROGRAM', selectedProgram); // eslint-disable-line
			console.log('SELECTED BUSINESSUNIT', selectedBunit); // eslint-disable-line
			console.log('SELECTED CURRENCY', selectedCurrency[0]); // eslint-disable-line
			// setPage will change the selected view to the page you indicate.
			// This is the actual page name not the display name.
			//console.log('selectedCountry', selectedCountry[0].length);
			setUserSelectedCurrency(selectedCurrency[0]);
			if (
				selectedCountry &&
				selectedCountry?.length == 0 &&
				selectedProgram &&
				selectedProgram?.length == 0 &&
				selectedBunit &&
				selectedBunit?.length == 0
			) {
				await resetAllFilters('SEARCH');
				//await reportOne.reload();
				setTimeout(async function () {
					await updateDataByDate(visuals);
				}, 8000);
			} else {
				updateDataByDate(visuals);
				try {
					const countryFilter = {
						$schema: 'http://powerbi.com/product/schema#basic',
						target: {
							table: 'F_RT_PRF_OPR_V',
							column: 'MasterCountryName'
						},
						operator: 'In',
						values: selectedCountry[0] ? selectedCountry[0] : []
					};

					const programFilter = {
						$schema: 'http://powerbi.com/product/schema#basic',
						target: {
							table: 'F_RT_PRF_OPR_V',
							column: 'ProgramTemplate'
						},
						operator: 'In',
						values: selectedProgram[0] ? selectedProgram[0] : []
					};

					const businessUnitFilter = {
						$schema: 'http://powerbi.com/product/schema#basic',
						target: {
							table: 'F_RT_PRF_OPR_V',
							column: 'Business Unit'
						},
						operator: 'In',
						values: selectedBunit[0] ? selectedBunit[0] : []
					};

					// let's filter data translations for Spanish
					let languageToLoad = props?.userSelectedlanguage?.toLowerCase();
					console.log('languageToLoad', languageToLoad); // eslint-disable-line
					// create filter object
					const langFilter = [
						{
							$schema: 'http://powerbi.com/product/schema#basic',
							target: { table: 'dim_Language', column: 'Language' },
							operator: 'In',
							values: [languageToLoad], // <- Filter based on Spanish
							filterType: models.FilterType.Basic,
							requireSingleSelection: true
						}
					];

					// Add the filter to the report's filters.
					try {
						if (selectedCountry[0] && selectedCountry[0].length > 0) {
							if (reportOne) {
								await reportOne.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportOne.updateFilters(models.FiltersOperations.Replace, [countryFilter]);
							}
							if (reportTwo) {
								await reportTwo.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportTwo.updateFilters(models.FiltersOperations.Replace, [countryFilter]);
							}
							if (reportThree) {
								await reportThree.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportThree.updateFilters(models.FiltersOperations.Replace, [countryFilter]);
							}
							if (reportFour) {
								await reportFour.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportFour.updateFilters(models.FiltersOperations.Replace, [countryFilter]);
							}
						}
						if (selectedProgram[0] && selectedProgram[0].length > 0) {
							if (reportOne) {
								await reportOne.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportOne.updateFilters(models.FiltersOperations.Replace, [programFilter]);
							}
							if (reportTwo) {
								await reportTwo.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportTwo.updateFilters(models.FiltersOperations.Replace, [programFilter]);
							}
							if (reportThree) {
								await reportThree.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportThree.updateFilters(models.FiltersOperations.Replace, [programFilter]);
							}
							if (reportFour) {
								await reportFour.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportFour.updateFilters(models.FiltersOperations.Replace, [programFilter]);
							}
						}
						if (selectedBunit[0] && selectedBunit[0].length > 0) {
							if (reportOne) {
								await reportOne.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportOne.updateFilters(models.FiltersOperations.Replace, [businessUnitFilter]);
							}
							if (reportTwo) {
								await reportTwo.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportTwo.updateFilters(models.FiltersOperations.Replace, [businessUnitFilter]);
							}
							if (reportThree) {
								await reportThree.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportThree.updateFilters(models.FiltersOperations.Replace, [businessUnitFilter]);
							}
							if (reportFour) {
								await reportFour.updateFilters(models.FiltersOperations.Replace, langFilter);
								await reportFour.updateFilters(models.FiltersOperations.Replace, [businessUnitFilter]);
							}
						}

						console.log('Report filter was added.'); // eslint-disable-line
					} catch (errors) {
						console.log(errors); // eslint-disable-line
					}
				} catch (errors) {
					console.log(errors); // eslint-disable-line
				}
			}
		} catch (errors) {
			console.log(errors); // eslint-disable-line
		}
	};
	const updateDataByDate = async visuals => {
		console.log('GROUPA DATE FILTER', visuals); // eslint-disable-line
		let selectedDate = [];
		let dateslicer = visuals.filter(function (visual) {
			return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_FILTER_DATE'].trim();
		})[0];

		// Get the slicer state
		const datestate = await dateslicer.getSlicerState();
		//console.log(datestate.filters[0].conditions);
		if (datestate?.filters[0]?.conditions[0]) {
			selectedDate.push(datestate.filters[0].conditions[0]);
		}
		if (datestate?.filters[0]?.conditions[1]) {
			selectedDate.push(datestate.filters[0].conditions[1]);
		}
		console.log('GROUPA SELECTED DATE IN FILTER', selectedDate); // eslint-disable-line

		// Create the filter object. For more information see https://go.microsoft.com/fwlink/?linkid=2153364
		const datefilter = {
			$schema: 'http://powerbi.com/product/schema#advanced',
			target: {
				table: 'Dim_dates',
				column: 'Date'
			},
			filterType: models.FilterType.Advanced,
			logicalOperator: 'And',
			conditions: selectedDate
		};

		// Retrieve the page collection and get the visuals for the active page.
		try {
			if (reportOne) {
				const keyPages = await reportOne.getPages();
				// Retrieve the active page.
				let keypage = keyPages.filter(function (page) {
					return page.isActive;
				})[0];
				const visuals = await keypage.getVisuals();
				// Retrieve the target visual.
				console.log(props?.groupAConfig['GROUPA_KEY_STATISTICS_DATE'].trim(), 'ONE', visuals); // eslint-disable-line
				let slicer = visuals.filter(function (visual) {
					return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_KEY_STATISTICS_DATE'].trim();
				})[0];
				// Set the slicer state which contains the slicer filters.
				if (slicer) await slicer.setSlicerState({ filters: [datefilter] });
			}
			if (reportTwo) {
				const statPages = await reportTwo.getPages();
				// Retrieve the active page.
				let statpage = statPages.filter(function (page) {
					return page.isActive;
				})[0];
				const visuals = await statpage.getVisuals();
				console.log(props?.groupAConfig['GROUPA_SATISFACTION_DATE'].trim(), 'TWO', visuals); // eslint-disable-line
				// Retrieve the target visual.
				let slicer = visuals.filter(function (visual) {
					return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_SATISFACTION_DATE'].trim();
				})[0];
				// Set the slicer state which contains the slicer filters.
				if (slicer) await slicer.setSlicerState({ filters: [datefilter] });
			}
			if (reportThree) {
				const outcomePages = await reportThree.getPages();
				// Retrieve the active page.
				let outcomepage = outcomePages.filter(function (page) {
					return page.isActive;
				})[0];
				const visuals = await outcomepage.getVisuals();
				console.log(props?.groupAConfig['GROUPA_OUTCOME_DATE'].trim(), 'THREE', visuals); // eslint-disable-line
				// Retrieve the target visual.
				let slicer = visuals.filter(function (visual) {
					return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_OUTCOME_DATE'].trim();
				})[0];
				// Set the slicer state which contains the slicer filters.
				if (slicer) await slicer.setSlicerState({ filters: [datefilter] });
			}
			if (reportFour) {
				const invoicePages = await reportFour.getPages();
				// Retrieve the active page.
				let invoicepage = invoicePages.filter(function (page) {
					return page.isActive;
				})[0];
				const visuals = await invoicepage.getVisuals();
				console.log(props?.groupAConfig['GROUPA_INVOICING_DATE'].trim(), 'FOUR', visuals); // eslint-disable-line
				// Retrieve the target visual.
				let slicer = visuals.filter(function (visual) {
					return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_INVOICING_DATE'].trim();
				})[0];
				// Set the slicer state which contains the slicer filters.
				if (slicer) await slicer.setSlicerState({ filters: [datefilter] });
			}
		} catch (errors) {
			console.log(errors); // eslint-disable-line
		}
		//await report.updateFilters(models.FiltersOperations.RemoveAll);
		//await reportOne.updateFilters(models.FiltersOperations.RemoveAll);
		//await reportOne.updateFilters(models.FiltersOperations.Add, [dateFilter]);
		//GET DATE ENDS
	};

	const resetAllFilters = async action => {
		// Remove the filters currently applied to the report.
		try {
			if (action === 'RESET') {
				await report.reload();
				setUserSelectedCurrency('DEFAULT');
			}
			if (reportOne) await reportOne.reload();
			if (reportTwo) await reportTwo.reload();
			if (reportThree) await reportThree.reload();
			if (reportFour) await reportFour.reload();
			//await updateDataByDate(visuals);
		} catch (errors) {
			console.log(errors); // eslint-disable-line
		}
	};

	/* For Performance Testing  Starts*/
	const [keycount, setKeyCount] = useState(0);
	const [satcount, setSatCount] = useState(0);
	const [outcount, setOutCount] = useState(0);
	const [invcount, setInvCount] = useState(0);

	useEffect(() => {
		console.log('allowedSections', allowedSections, 'enableKeyBtn', enableKeyBtn); // eslint-disable-line
		const interval = setInterval(() => {
			if ((enableKeyBtn === null || enableKeyBtn === false) && enableKeySection === true) {
				setKeyCount(keycount + 1);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [keycount, enableKeySection]);

	useEffect(() => {
		console.log('enableKeyBtn', enableSatBtn); // eslint-disable-line
		const interval = setInterval(() => {
			if ((enableSatBtn === null || enableSatBtn === false) && enableSatSection === true) {
				setSatCount(satcount + 1);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [satcount, enableSatSection]);

	useEffect(() => {
		const interval = setInterval(() => {
			if ((enableOutBtn === null || enableOutBtn === false) && enableOutSection === true) {
				setOutCount(outcount + 1);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [outcount, enableOutSection]);

	useEffect(() => {
		const interval = setInterval(() => {
			if ((enableInvBtn === null || enableInvBtn === false) && enableInvSection === true) {
				setInvCount(invcount + 1);
			}
		}, 1000);
		return () => clearInterval(interval);
	}, [invcount, enableInvSection]);
	/* For Performance Testing  Ends*/
	const enableNextSection = sectionIndex => {
		console.log('NEXT SECTION TO ENABLE', allowedSections[sectionIndex]); // eslint-disable-line
		if (allowedSections[sectionIndex] === 'KEYSTATISTICS') {
			setEnableKeySection(true);
		} else if (allowedSections[sectionIndex] === 'SATISFACTION') {
			setEnableSatSection(true);
		} else if (allowedSections[sectionIndex] === 'OUTCOMES') {
			setEnableOutSection(true);
		} else if (allowedSections[sectionIndex] === 'INVOICING') {
			setEnableInvSection(true);
		}
	};

	const assignCurrencyToInvoice = async reportFour => {
		//Create the filter object. For more information see https://go.microsoft.com/fwlink/?linkid=2153364
		let currencyCode =
			userSelectedCurrency != 'DEFAULT' ? userSelectedCurrency : sessionStorage?.getItem('GROUPA_CURRENCY_CODE');
		//console.log('currencyCode:::', currencyCode); // eslint-disable-line
		const filter = {
			$schema: 'http://powerbi.com/product/schema#basic',
			target: {
				table: 'dim_Currency',
				column: 'CURCODE'
			},
			operator: 'In',
			values: [currencyCode]
		};
		try {
			const pages = await reportFour.getPages();
			// Retrieve the active page.
			let page = pages.filter(function (page) {
				return page.isActive;
			})[0];

			const visuals = await page.getVisuals();
			console.log('GROUPA_INVOICING_CURRENCY', visuals); // eslint-disable-line
			// Retrieve the target visual.
			let slicer = visuals.filter(function (visual) {
				return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_INVOICING_CURRENCY']?.trim();
			})[0];
			// Set the slicer state which contains the slicer filters.
			await slicer.setSlicerState({ filters: [filter] });
		} catch (errors) {
			console.log(errors); // eslint-disable-line
		}
	};

	const assignCurrencyToKeyStatistics = async reportOne => {
		//Create the filter object. For more information see https://go.microsoft.com/fwlink/?linkid=2153364
		let currencyCode =
			userSelectedCurrency != 'DEFAULT' ? userSelectedCurrency : sessionStorage?.getItem('GROUPA_CURRENCY_CODE');
		//console.log('currencyCode:::', currencyCode); // eslint-disable-line
		const filter = {
			$schema: 'http://powerbi.com/product/schema#basic',
			target: {
				table: 'dim_Currency',
				column: 'CURCODE'
			},
			operator: 'In',
			values: [currencyCode]
		};
		try {
			const pages = await reportOne.getPages();
			// Retrieve the active page.
			let page = pages.filter(function (page) {
				return page.isActive;
			})[0];

			const visuals = await page.getVisuals();
			console.log('GROUPA_KEY_STATISTICS_CURRENCY', visuals); // eslint-disable-line
			// Retrieve the target visual.
			let slicer = visuals.filter(function (visual) {
				return (
					visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_KEY_STATISTICS_CURRENCY']?.trim()
				);
			})[0];
			// Set the slicer state which contains the slicer filters.
			await slicer.setSlicerState({ filters: [filter] });
		} catch (errors) {
			console.log(errors); // eslint-disable-line
		}
	};

	const assignCurrencyToFilter = async report => {
		//Create the filter object. For more information see https://go.microsoft.com/fwlink/?linkid=2153364
		let currencyCode =
			userSelectedCurrency != 'DEFAULT' ? userSelectedCurrency : sessionStorage?.getItem('GROUPA_CURRENCY_CODE');
		//console.log('currencyCodeeeeee:::', currencyCode); // eslint-disable-line
		const filter = {
			$schema: 'http://powerbi.com/product/schema#basic',
			target: {
				table: 'dim_Currency',
				column: 'CURCODE'
			},
			operator: 'In',
			values: [currencyCode]
		};
		try {
			const pages = await report.getPages();
			// Retrieve the active page.
			let page = pages.filter(function (page) {
				return page.isActive;
			})[0];

			const visuals = await page.getVisuals();
			console.log('GROUPA_FILTER_CURRENCY::', visuals); // eslint-disable-line
			// Retrieve the target visual.
			let slicer = visuals.filter(function (visual) {
				return visual.type === 'slicer' && visual.name === props?.groupAConfig['GROUPA_FILTER_CURRENCY']?.trim();
			})[0];
			// Set the slicer state which contains the slicer filters.
			await slicer.setSlicerState({ filters: [filter] });
		} catch (errors) {
			console.log(errors); // eslint-disable-line
		}
	};

	useEffect(() => {
		if (enableKeyBtn) assignCurrencyToKeyStatistics(reportOne);
	}, [reportOne, enableKeyBtn, userSelectedCurrency]);

	useEffect(() => {
		if (enableInvBtn) assignCurrencyToInvoice(reportFour);
	}, [reportFour, enableInvBtn, userSelectedCurrency]);

	useEffect(() => {
		if (enableSearch) assignCurrencyToFilter(report);
	}, [report, enableSearch, userSelectedCurrency]);

	return (
		<>
			{props?.pagedata && (
				<div className="container-fluid container-lg mt-3 mb-3 mt-lg-0 mb-lg-0 p-0 p-sm-2 p-md-2 p-lg-3">
					<table
						style={{
							display: 'none',
							background: '#fff',
							border: '1px solid #000000',
							position: 'fixed',
							top: '250px',
							zIndex: '4000'
						}}>
						<thead>
							<tr>
								<th style={{ border: '1px solid #000000', padding: '5px' }}>KEYSTATISTICS</th>
								<th style={{ border: '1px solid #000000', padding: '5px' }}>SATISFACTION</th>
								<th style={{ border: '1px solid #000000', padding: '5px' }}>OUTCOMES</th>
								<th style={{ border: '1px solid #000000', padding: '5px' }}>INVOICING</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td style={{ border: '1px solid #000000', color: 'red', padding: '5px' }}>{keycount + ' Secs'}</td>
								<td style={{ border: '1px solid #000000', color: 'blue', padding: '5px' }}>{satcount + ' Secs'}</td>
								<td style={{ border: '1px solid #000000', color: 'green', padding: '5px' }}>{outcount + ' Secs'}</td>
								<td style={{ border: '1px solid #000000', color: 'black', padding: '5px' }}>{invcount + ' Secs'}</td>
							</tr>
						</tbody>
					</table>
					<div className="row groupaContainer">
						<div className="col-12 p-0 p-sm-2 p-md-0">
							<div className="row p-0">
								<div className="col-12 title">{props?.pagedata?.title}</div>
								<div className="col-12 desc">
									<span>{props?.pagedata?.description}</span>
								</div>
								<div className="col-9 p-0">
									<div className="col-12 jumpTo d-block">{props?.pagedata?.jumptotitle}</div>
									<div className="col-12 navigationBlock d-flex flex-column align-items-start flex-lg-row gap-2">
										{dashboardAccess.KEYSTATISTICS && enableKeyBtn && (
											<button
												type="button"
												className="btn btn-outline-secondary"
												onClick={() => window.scrollTo({ behavior: 'smooth', top: myOneRef.current.offsetTop })}>
												{props?.pagedata?.jumptolables['Dashboard.GroupA.KeyStatistics']}
												<img src={Arrowdiagonal} alt="Arrow Diagonal" />
											</button>
										)}
										{dashboardAccess.SATISFACTION && enableSatBtn && (
											<button
												type="button"
												className="btn btn-outline-secondary"
												onClick={() => window.scrollTo({ behavior: 'smooth', top: myTwoRef.current.offsetTop })}>
												{props?.pagedata?.jumptolables['Dashboard.GroupA.Satisfaction']}
												<img src={Arrowdiagonal} alt="Arrow Diagonal" />
											</button>
										)}
										{dashboardAccess.OUTCOMES && enableOutBtn && (
											<button
												type="button"
												className="btn btn-outline-secondary"
												onClick={() => window.scrollTo({ behavior: 'smooth', top: myThreeRef.current.offsetTop })}>
												{props?.pagedata?.jumptolables['Dashboard.GroupA.Outcomes']}
												<img src={Arrowdiagonal} alt="Arrow Diagonal" />
											</button>
										)}
										{dashboardAccess.INVOICING && enableInvBtn && (
											<button
												type="button"
												className="btn btn-outline-secondary"
												onClick={() => window.scrollTo({ behavior: 'smooth', top: myFourRef.current.offsetTop })}>
												{props?.pagedata?.jumptolables['Dashboard.GroupA.Invoicing']}
												<img src={Arrowdiagonal} alt="Arrow Diagonal" />
											</button>
										)}
									</div>
								</div>
								<div className="col-3 pt-3 text-end">
									<div className="col-12">
										{/* <button
										type="button"
										className="btn btn-secondary rounded-pill filterBtn"
										onClick={() => setShowfilter(!showfilter)}>
										<img src={Filtericon} />
										Filter Dashboard
									</button> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			{/* {!enableFilter && enableFilter != null && <Spinner />} */}
			{powerBIOneData && (
				<div>
					<PowerBIEmbed
						title="Power BI Report"
						embedConfig={{
							type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
							id: sessionStorage.getItem('GROUPA_REPORT_ID'),
							embedUrl: sessionStorage.getItem('GROUPA_EMBED_URL'),
							accessToken: sessionStorage.getItem('GROUPA_ACCESS_TOKEN'),
							tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
							//localeSettings: { language: props?.userSelectedlanguage.toLowerCase() },
							pageName: props?.groupAConfig['GROUPA_FILTERS'].trim(),
							settings: {
								panes: {
									filters: {
										expanded: false,
										visible: false
									},
									pageNavigation: { visible: false }
								},
								background: models.BackgroundType.Transparent,
								//layoutType: isSmallDevice ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
								layoutType: models.LayoutType.Custom,
								customLayout: {
									displayOption: models.DisplayOption.FitToPage
								}
							}
						}}
						/* eslint-disable */
						eventHandlers={
							new Map([
								[
									'loaded',
									function () {
										console.log('Report loaded');
										//setEnableFilter(false);
										setEnableSearch(false);
									}
								],
								[
									'rendered',
									function () {
										console.log('Report rendered');
										//setEnableFilter(true);
										setEnableSearch(true);
									}
								],
								[
									'error',
									function (event) {
										console.log(event.detail);
									}
								],
								['visualClicked', () => console.log('visual clicked')],
								['pageChanged', event => console.log(event)]
							])
						}
						cssClassName={'filter-container'}
						getEmbeddedComponent={embeddedReport => {
							window.report = embeddedReport;
							setReport(embeddedReport);
						}}
					/>
				</div>
			)}
			{enableSearch && (
				<div className="d-flex flex-column flex-sm-row flex-md-row flex-lg-row gap-2 mb-3 mt-md-1 mb-lg-0 searchContainer">
					<button
						type="button"
						className="btn btn-outline-secondary rounded-pill filterResetBtn"
						onClick={() => resetAllFilters('RESET')}>
						{props?.tabTitles['Dashboard.Submenu.Reset']}
					</button>
					<button
						type="button"
						className="btn btn-outline-secondary rounded-pill filterSearchBtn"
						onClick={() => updateReport()}>
						{props?.tabTitles['Dashboard.Submenu.ApplyChanges']}
					</button>
				</div>
			)}
			{!enableKeyBtn && enableKeyBtn != null && <Spinner />}
			{powerBIOneData && enableKeySection && dashboardAccess.KEYSTATISTICS && (
				<div ref={myOneRef} style={{ visibility: !enableKeyBtn ? 'hidden' : '' }}>
					{/* <div ref={myOneRef}> */}
					<PowerBIEmbed
						title="Power BI Report"
						embedConfig={{
							type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
							id: sessionStorage.getItem('GROUPA_REPORT_ID'),
							embedUrl: sessionStorage.getItem('GROUPA_EMBED_URL'),
							accessToken: sessionStorage.getItem('GROUPA_ACCESS_TOKEN'),
							tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
							//localeSettings: { language: props?.userSelectedlanguage.toLowerCase() },
							pageName: props?.groupAConfig['GROUPA_KEY_STATISTICS'].trim(),
							settings: {
								panes: {
									filters: {
										expanded: false,
										visible: false
									},
									pageNavigation: { visible: false }
								},
								background: models.BackgroundType.Transparent,
								layoutType: models.LayoutType.Custom,
								//layoutType: isSmallDevice ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
								customLayout: {
									displayOption: models.DisplayOption.FitToPage
								}
							}
						}}
						/* eslint-disable */
						eventHandlers={
							new Map([
								[
									'loaded',
									function () {
										console.log('Report loaded KEY');
										setEnableKeyBtn(false);
									}
								],
								[
									'rendered',
									function () {
										console.log('Report Rendered KEY');
										setEnableKeyBtn(true);
										if (allowedSections.includes('KEYSTATISTICS')) {
											console.log('KEYSTATISTICS', allowedSections.indexOf('KEYSTATISTICS'));
											enableNextSection(allowedSections.indexOf('KEYSTATISTICS') + 1);
										}
									}
								],
								[
									'error',
									function (event) {
										console.log(event.detail);
									}
								],
								['visualClicked', () => console.log('visual clicked')],
								['pageChanged', event => console.log(event)]
							])
						}
						cssClassName={'keystat-container'}
						getEmbeddedComponent={embeddedReport => {
							window.report = embeddedReport;
							setReportOne(embeddedReport);
						}}
					/>
				</div>
			)}
			{!enableSatBtn && enableSatBtn != null && <Spinner />}
			{powerBIOneData && enableSatSection && dashboardAccess.SATISFACTION && (
				<div ref={myTwoRef} style={{ visibility: !enableSatBtn ? 'hidden' : '' }}>
					{/* <div ref={myTwoRef}> */}
					<PowerBIEmbed
						title="Power BI Report"
						embedConfig={{
							type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
							id: sessionStorage.getItem('GROUPA_REPORT_ID'),
							embedUrl: sessionStorage.getItem('GROUPA_EMBED_URL'),
							accessToken: sessionStorage.getItem('GROUPA_ACCESS_TOKEN'),
							tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
							//localeSettings: { language: props?.userSelectedlanguage.toLowerCase() },
							pageName: props?.groupAConfig['GROUPA_SATISFACTION'].trim(),
							settings: {
								panes: {
									filters: {
										expanded: false,
										visible: false
									},
									pageNavigation: { visible: false }
								},
								background: models.BackgroundType.Transparent,
								layoutType: models.LayoutType.Custom,
								//layoutType: isSmallDevice ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
								customLayout: {
									displayOption: models.DisplayOption.FitToPage
								}
							}
						}}
						/* eslint-disable */
						eventHandlers={
							new Map([
								[
									'loaded',
									function () {
										setEnableSatBtn(false);
										console.log('Report loaded');
									}
								],
								[
									'rendered',
									function () {
										setEnableSatBtn(true);
										if (allowedSections.includes('SATISFACTION')) {
											console.log('SATISFACTION', allowedSections.indexOf('SATISFACTION'));
											enableNextSection(allowedSections.indexOf('SATISFACTION') + 1);
										}
									}
								],
								[
									'error',
									function (event) {
										console.log(event.detail);
									}
								],
								['visualClicked', () => console.log('visual clicked')],
								['pageChanged', event => console.log(event)]
							])
						}
						cssClassName={'satisf-container'}
						getEmbeddedComponent={embeddedReport => {
							window.report = embeddedReport;
							setReportTwo(embeddedReport);
						}}
					/>
				</div>
			)}
			{!enableOutBtn && enableOutBtn != null && <Spinner />}
			{powerBIOneData && enableOutSection && dashboardAccess.OUTCOMES && (
				<div ref={myThreeRef} style={{ visibility: !enableOutBtn ? 'hidden' : '' }}>
					{/* <div ref={myThreeRef}> */}
					<PowerBIEmbed
						title="Power BI Report"
						embedConfig={{
							type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
							id: sessionStorage.getItem('GROUPA_REPORT_ID'),
							embedUrl: sessionStorage.getItem('GROUPA_EMBED_URL'),
							accessToken: sessionStorage.getItem('GROUPA_ACCESS_TOKEN'),
							tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
							//localeSettings: { language: props?.userSelectedlanguage.toLowerCase() },
							pageName: props?.groupAConfig['GROUPA_OUTCOME'].trim(),
							settings: {
								panes: {
									filters: {
										expanded: false,
										visible: false
									},
									pageNavigation: { visible: false }
								},
								background: models.BackgroundType.Transparent,
								layoutType: models.LayoutType.Custom,
								//layoutType: isSmallDevice ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
								customLayout: {
									displayOption: models.DisplayOption.FitToPage
								}
							}
						}}
						/* eslint-disable */
						eventHandlers={
							new Map([
								[
									'loaded',
									function () {
										console.log('Report loaded');
										setEnableOutBtn(false);
									}
								],
								[
									'rendered',
									function () {
										setEnableOutBtn(true);
										if (allowedSections.includes('OUTCOMES')) {
											console.log('OUTCOMES', allowedSections.indexOf('OUTCOMES'));
											enableNextSection(allowedSections.indexOf('OUTCOMES') + 1);
										}
									}
								],
								[
									'error',
									function (event) {
										console.log(event.detail);
									}
								],
								['visualClicked', () => console.log('visual clicked')],
								['pageChanged', event => console.log(event)]
							])
						}
						cssClassName={'outcome-container'}
						getEmbeddedComponent={embeddedReport => {
							window.report = embeddedReport;
							setReportThree(embeddedReport);
						}}
					/>
				</div>
			)}
			{!enableInvBtn && enableInvBtn != null && <Spinner />}
			{powerBIOneData && enableInvSection && dashboardAccess.INVOICING && (
				<div ref={myFourRef} style={{ visibility: !enableInvBtn ? 'hidden' : '' }}>
					{/* <div ref={myFourRef}> */}
					<PowerBIEmbed
						title="Power BI Report"
						embedConfig={{
							type: 'report', // Supported types: report, dashboard, tile, visual, qna, paginated report and create
							id: sessionStorage.getItem('GROUPA_REPORT_ID'),
							embedUrl: sessionStorage.getItem('GROUPA_EMBED_URL'),
							accessToken: sessionStorage.getItem('GROUPA_ACCESS_TOKEN'),
							tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed
							//localeSettings: { language: props?.userSelectedlanguage.toLowerCase() },
							pageName: props?.groupAConfig['GROUPA_INVOICING'].trim(),
							settings: {
								panes: {
									filters: {
										expanded: false,
										visible: false
									},
									pageNavigation: { visible: false }
								},
								background: models.BackgroundType.Transparent,
								layoutType: models.LayoutType.Custom,
								//layoutType: isSmallDevice ? models.LayoutType.MobilePortrait : models.LayoutType.Custom,
								customLayout: {
									displayOption: models.DisplayOption.FitToPage
								}
							}
						}}
						/* eslint-disable */
						eventHandlers={
							new Map([
								[
									'loaded',
									function () {
										console.log('Report loaded');
										setEnableInvBtn(false);
									}
								],
								[
									'rendered',
									function () {
										setEnableInvBtn(true);
										if (allowedSections.includes('INVOICING')) {
											console.log('INVOICING', allowedSections.indexOf('INVOICING'));
											enableNextSection(allowedSections.indexOf('INVOICING') + 1);
										}
									}
								],
								[
									'error',
									function (event) {
										console.log(event.detail);
									}
								],
								['visualClicked', () => console.log('visual clicked')],
								['pageChanged', event => console.log(event)]
							])
						}
						cssClassName={'invoice-container'}
						getEmbeddedComponent={embeddedReport => {
							window.report = embeddedReport;
							setReportFour(embeddedReport);
						}}
					/>
				</div>
			)}
		</>
	);
};

const mapStateToProps = state => {
	return {
		userSelectedlanguage: state.userSlice.userSelectedlanguage,
		headerPageContent: state.userSlice.headerPageContent,
		isLangChanged: state.userSlice.isLangChanged
	};
};

const mapDispatchToProps = dispatch => {
	return {
		switchLanguage: shortLang => dispatch(SwitchLanguage(shortLang)),
		reset: () => dispatch(Reset())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupA);
